var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4336_253235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 34,
    height: 34,
    rx: 17,
    fill: "url(#paint0_linear_4336_253235)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4336_253235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0899 17.0436C28.6238 17.1623 28.2547 17.4873 28.0983 17.9311C28.0483 18.0654 28.0295 18.2248 28.0139 18.5779C27.9951 18.9904 27.9826 19.0686 27.9106 19.2217C27.7511 19.5654 27.5197 19.7561 27.1036 19.8748C26.9753 19.9123 26.844 19.9498 26.8158 19.9561C26.7783 19.9686 26.7595 19.9561 26.7595 19.9217C26.7595 19.8092 26.6312 19.6248 26.5093 19.5623C26.3936 19.5029 26.3278 19.4998 25.3519 19.4998C24.3759 19.4998 24.3102 19.5029 24.1945 19.5623C24.1132 19.6029 24.0475 19.6686 24.0068 19.7498C23.9474 19.8654 23.9443 19.9311 23.9443 20.9686V22.0623H21.1134C19.1239 22.0623 18.2356 22.0717 18.1198 22.0967C17.5818 22.2123 17.147 22.6467 17.0344 23.1811C17.0094 23.2998 17 24.6967 17 27.9873C17 32.5748 17 32.6279 17.0626 32.7498C17.1345 32.8904 17.3128 32.9998 17.4692 32.9998C17.6037 32.9998 17.6913 32.9498 18.6422 32.3155L19.4868 31.7498H24.0131C27.2256 31.7498 28.5863 31.7405 28.7052 31.7154C29.2369 31.6029 29.678 31.1592 29.7906 30.6311C29.8156 30.5186 29.825 29.6748 29.825 27.9529V25.4436L30.7415 25.4311C31.5861 25.4186 31.6674 25.4123 31.8395 25.3498C32.365 25.1561 32.7498 24.7686 32.928 24.2561C33 24.0467 33 24.0373 33 22.4686C33 20.8998 33 20.8904 32.928 20.6811C32.7498 20.1686 32.3587 19.7748 31.8395 19.5904C31.7018 19.5404 31.5517 19.5186 31.242 19.5092L30.826 19.4904V18.8873C30.826 18.5561 30.8104 18.2092 30.7915 18.1186C30.7321 17.8498 30.607 17.6248 30.4037 17.4186C30.0534 17.0654 29.5622 16.9248 29.0899 17.0436ZM29.6373 17.9998C29.7187 18.0404 29.7844 18.1061 29.825 18.1873C29.8844 18.3029 29.8876 18.3686 29.8876 19.1873C29.8876 20.0061 29.8907 20.0717 29.9501 20.1873C30.0627 20.4092 30.1659 20.4373 30.8354 20.4373C31.5079 20.4373 31.6393 20.4686 31.8426 20.6717C32.074 20.9029 32.0772 20.9217 32.0772 22.4686C32.0772 24.0154 32.074 24.0342 31.8426 24.2654C31.608 24.503 31.633 24.4998 29.703 24.4998C28.3079 24.4998 27.9607 24.4904 27.798 24.4529C27.4414 24.3686 27.0598 24.1342 26.869 23.8811L26.7595 23.7404V22.3436V20.9498L27.1756 20.8311C27.8575 20.6404 28.1797 20.4467 28.5019 20.0467C28.8084 19.6654 28.946 19.2279 28.9492 18.6404C28.9523 18.2404 28.9929 18.1279 29.1869 18.0123C29.337 17.9217 29.4747 17.9186 29.6373 17.9998ZM25.8211 22.4686V24.4998H25.3519H24.8827V22.4686V20.4373H25.3519H25.8211V22.4686ZM23.9443 24.0311C23.9443 25.0061 23.9474 25.0717 24.0068 25.1873C24.0475 25.2686 24.1132 25.3342 24.1945 25.3748C24.3102 25.4342 24.3759 25.4373 25.3519 25.4373C26.331 25.4373 26.3936 25.4342 26.5124 25.3748C26.6 25.3279 26.6563 25.2686 26.7032 25.1717L26.7689 25.0342L27.0192 25.1592C27.4196 25.3623 27.6573 25.4123 28.3173 25.4279L28.8866 25.4436V27.9436C28.8866 30.3811 28.8866 30.4436 28.824 30.5623C28.6927 30.8154 29.1337 30.7936 23.8661 30.8123L19.174 30.8279L18.5578 31.2436L17.9384 31.6561V27.5092C17.9415 23.5748 17.9447 23.3529 17.9978 23.253C18.0291 23.1967 18.1073 23.1154 18.1761 23.0748L18.2981 22.9998H21.1228H23.9443V24.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1188 24.9406C18.9844 25.0093 18.875 25.1937 18.875 25.3438C18.875 25.5 18.9844 25.6781 19.125 25.75C19.2438 25.8094 19.3062 25.8125 20.9062 25.8125C22.5062 25.8125 22.5687 25.8094 22.6875 25.75C22.8281 25.6781 22.9375 25.5 22.9375 25.3438C22.9375 25.1875 22.8281 25.0094 22.6875 24.9375C22.5687 24.8782 22.5094 24.875 20.9 24.875C19.3031 24.8782 19.2281 24.8812 19.1188 24.9406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1188 26.8156C18.9844 26.8843 18.875 27.0687 18.875 27.2188C18.875 27.375 18.9844 27.5531 19.125 27.625C19.2469 27.6875 19.3 27.6875 23.4062 27.6875C27.5125 27.6875 27.5656 27.6875 27.6875 27.625C27.8281 27.5531 27.9375 27.375 27.9375 27.2188C27.9375 27.0625 27.8281 26.8844 27.6875 26.8125C27.5656 26.75 27.5125 26.75 23.4 26.75C19.3156 26.7532 19.2313 26.7531 19.1188 26.8156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1188 28.6906C18.9844 28.7593 18.875 28.9437 18.875 29.0938C18.875 29.25 18.9844 29.4281 19.125 29.5C19.2469 29.5625 19.3 29.5625 23.4062 29.5625C27.5125 29.5625 27.5656 29.5625 27.6875 29.5C27.8281 29.4281 27.9375 29.25 27.9375 29.0938C27.9375 28.9375 27.8281 28.7594 27.6875 28.6875C27.5656 28.625 27.5125 28.625 23.4 28.625C19.3156 28.6282 19.2313 28.6281 19.1188 28.6906Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4336_253235",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4336_253235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4336_253235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4336_253235",
    x1: 25,
    y1: 8,
    x2: 25,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#FCB034"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4336_253235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.e67af6bdc3e59b7c89e72120a69b3b34.svg";
export { ForwardRef as ReactComponent };